export { retry } from './retry';

export interface PollingOptions<T> {
  maxAttempts?: number;
  intervalMs?: number;
  isInProgress: (result: T) => boolean;
  onComplete: (result: T) => void;
  onPoll?: (result: T, attempt: number) => void;
}

export async function poll<T>(
  fetchFn: () => Promise<{ data: T }>,
  options: PollingOptions<T>
): Promise<T> {
  const {
    maxAttempts = 30,
    intervalMs = 2000,
    isInProgress,
    onComplete,
    onPoll
  } = options;

  let attempts = 0;

  const execute = async (): Promise<T> => {
    attempts++;

    const response = await fetchFn();
    const result = response.data;

    if (onPoll) {
      onPoll(result, attempts);
    }


    if (isInProgress(result)) {

      if (attempts >= maxAttempts) {
        throw new Error(
          `Polling timeout: maximum attempts (${maxAttempts}) reached after ${attempts * intervalMs / 1000}s`
        );
      }

      await new Promise((resolve) => setTimeout(resolve, intervalMs));
      return execute();
    }

    onComplete(result);
    return result;
  };

  return execute();
}


